import React, { Component } from 'react'
import image from '../../images/blog2.45719b89.webp'
import PeopleSvg from '../icons/PeopleSvg'
import CalendarSvg from '../icons/CalendarSvg'
import RightSvg from '../icons/RightSvg'
import { Link } from 'react-router-dom'

export class Card5 extends Component {
    render() {
        return (

            <div className='rounded-[8px] border-[1px]'>
                <div className='bg-[#79cbde] rounded-[8px_8px_0_0]'>
                    <img src={this.props.image} className='w-full h-[245px] rounded-[8px_8px_0_0]' />
                </div>

                <div className='p-[24px] flex flex-col h-[45%] gap-[16px] max-[440px]:p-[18px] max-[320px]:gap-[10px] max-[310px]:p-[12px]' >
                    {/* <div className='flex items-center gap-[16px] max-[310px]:flex-col max-[310px]:items-start '>
                        <div className='flex items-center gap-[6px]'>
                            <PeopleSvg />
                            <span className='text-[18px] font-[400] text-[#676879] max-[650px]:text-[16px]'>Jack William</span>
                        </div>
                        <div className='flex items-center gap-[6px]'>
                            <CalendarSvg />
                            <span className='text-[18px] font-[400] text-[#676879] max-[650px]:text-[16px]'>Feb 25</span>
                        </div>
                    </div> */}

                    <div className='flex flex-col h-full justify-between gap-[16px]'>
                        <h3 className='text-[20px] font-[600] text-[#2e2f46] max-[650px]:text-[18px]'>{this.props.title}</h3>

                        <Link to={this.props.path} className='flex '>
                            <button className='border-[2px] border-[#0E38B1] text-[#0E38B1] font-[500] text-[18px] rounded-[8px] gap-[8px] p-[8px_16px] flex items-center max-[650px]:text-[16px] max-[650px]:p-[6px_12px] max-[650px]:gap-[6px]
                                 max-[400px]:text-[14px] max-[400px]:p-[4px_7px] max-[400px]:border-[1px]
                            '>
                                Daha ətraflı

                                <RightSvg fill="#0E38B1" height="22" width="22" />
                            </button>
                        </Link>
                    </div>

                </div>
            </div>


        )
    }
}

export default Card5